import { Navigate, Route, Routes } from 'react-router-dom';

import MainLayout from '@/components/layout/main-layout';
import ProtectedRoute from '@/components/protected-route';
import ReleaseNotificationToaster from '@/components/release-notification-toaster';
import RoleProtectedRoute from '@/components/role-protected-route';
import Toaster from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import AuthContentProvider from '@/contexts/authentication/auth-context-provider';
import { MapConfigProvider } from '@/contexts/map-config/map-config-provider';
import AdminControlPanel from '@/pages/admin-control-panel';
import Home from '@/pages/home';
import SignInPage from '@/pages/sign-in-view';

const App = () => (
  <>
    <Toaster />
    <TooltipProvider delayDuration={0}>
      <AuthContentProvider>
        <ReleaseNotificationToaster />
        <MapConfigProvider>
          <Routes>
            <Route element={<MainLayout />}>
              <Route element={<ProtectedRoute />}>
                <Route path="/home" element={<Home />} />
                <Route
                  element={
                    <RoleProtectedRoute allowedRoles={['super_admin', 'admin', 'welldev']} />
                  }
                >
                  <Route path="/control-panel" element={<AdminControlPanel />} />
                </Route>
                <Route path="*" element={<Navigate to="/home" replace />} />
              </Route>
              <Route path="/login" element={<SignInPage />} />
            </Route>
          </Routes>
        </MapConfigProvider>
      </AuthContentProvider>
    </TooltipProvider>
  </>
);

export default App;
